import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

export default function CustomizedTables({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Категория</StyledTableCell>
            <StyledTableCell align="right">III юн.</StyledTableCell>
            <StyledTableCell align="right">II юн.</StyledTableCell>
            <StyledTableCell align="right">I юн.</StyledTableCell>
            <StyledTableCell align="right">III</StyledTableCell>
            <StyledTableCell align="right">II</StyledTableCell>
            <StyledTableCell align="right">I</StyledTableCell>
            <StyledTableCell align="right">КМС</StyledTableCell>
            <StyledTableCell align="right">МС</StyledTableCell>
            <StyledTableCell align="right">МСМК</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell component="th" scope="row">
                {row.category}
              </StyledTableCell>
              <StyledTableCell align="right">{row.third_j}</StyledTableCell>
              <StyledTableCell align="right">{row.second_j}</StyledTableCell>
              <StyledTableCell align="right">{row.first_j}</StyledTableCell>
              <StyledTableCell align="right">{row.third}</StyledTableCell>
              <StyledTableCell align="right">{row.second}</StyledTableCell>
              <StyledTableCell align="right">{row.first}</StyledTableCell>
              <StyledTableCell align="right">{row.kms}</StyledTableCell>
              <StyledTableCell align="right">{row.ms}</StyledTableCell>
              <StyledTableCell align="right">{row.msmk}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
